<div class="flow-textarea">
    <label><ng-content></ng-content></label>

    <div class="textarea-container">
        <textarea
            [cols]="cols"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [readOnly]="readonly"
            [rows]="rows"
            [tabIndex]="tabindex"
            [value]="value"
            (change)="handleChange($event)"
            (input)="handleInput($event)">
        </textarea>
    </div>
</div>
